import { graphql } from '~publish/graphql'

import { CollaborationNoteFields } from './CollaborationNoteFields'

export const CollaborationNoteWithActionsFields = graphql(
  `
    fragment CollaborationNoteWithActionsFields on CollaborationNote @_unmask {
      ...CollaborationNoteFields
      allowedActions
    }
  `,
  [CollaborationNoteFields],
)
